// لوحة متابعة الباحث (مجموعات المشاركين / العائلات).
export const suivi = {
  suivi_tab_label: "المتابعة",
  suivi_caption_todo: "{{count}} للمعالجة",
  suivi_caption_uptodate: "{{count}} محدّثة",
  suivi_caption_all_done: "كل شيء محدّث · {{count}} ملفات",
  suivi_search_placeholder: "رقم الملف…",
  suivi_search_no_match: "لا يوجد ملف يطابق «{{query}}»",
  suivi_group_todo_title: "للمعالجة",
  suivi_group_uptodate_title: "محدّثة",
  suivi_up_to_date_row: "لا شيء للقيام به",
  suivi_empty: "لا توجد ملفات بعد",
  suivi_dossier: "الملف {{code}}",
  suivi_family: "العائلة",
  suivi_group_title: "الملف",
  suivi_member_generic: "مشارك",
  suivi_action_fill: "استبيان واحد للتعبئة",
  suivi_action_fill_plural: "{{count}} استبيانات للتعبئة",
  suivi_action_remind: "للتذكير",
  suivi_action_remind_role: "تذكير · {{role}}",
  suivi_members: "الأعضاء",
  suivi_to_fill: "لتعبئتها من طرفكم",
  suivi_parents_side: "جانب المشاركين",
  suivi_history: "السجل",
  suivi_history_done: "{{count}} مكتملة",
  suivi_history_missed: "{{count}} فائتة",
  suivi_done_on: "أُنجز في {{date}}",
  suivi_missed_on: "انتهت المهلة · {{date}}",
  suivi_answered_by: "أجاب عنه {{who}}",
  suivi_answered_by_you: "أنت",
  suivi_to_answer_by: "يُعبَّأ من طرف {{who}}",
  suivi_questionnaire: "استبيان",
  suivi_fill: "تعبئة",
  suivi_continue_progress: "متابعة {{answered}}/{{total}}",
  suivi_filled_by_colleague: "عبّأه زميل",
  suivi_status_not_started: "لم يبدأ",
  suivi_status_in_progress: "قيد الإنجاز {{answered}}/{{total}}",
  suivi_call: "اتصال",
  suivi_copy_number: "نسخ الرقم",
  suivi_contact: "تواصل",
  suivi_copy_email: "نسخ البريد الإلكتروني",
  suivi_email_copied: "تم نسخ البريد الإلكتروني",
  suivi_copied: "تم نسخ الرقم",
  suivi_during_call: "أثناء المكالمة",
  suivi_minutes: "≈ {{count}} د",
  suivi_mark_reminded: "وضع علامة « تم التذكير اليوم »",
  suivi_reminded_on: "تم التذكير في {{date}}",
  suivi_empty_group: "لا شيء للقيام به لهذا الملف",
  suivi_next_window_fill: "لتعبئتها من طرفكم: {{label}} — تُفتح في {{date}}",
  suivi_next_window_subject: "{{role}}: {{label}} — تُفتح في {{date}}",
  suivi_home_next_window: "النافذة القادمة: {{date}} ({{group}})",
  suivi_due_today: "اليوم",
  suivi_due_tomorrow: "غدًا",
  suivi_due_in_days: "باقٍ {{count}} أيام",
  suivi_due_past: "منتهي",
  // « إضافة ملف » — إدارة الملفات من طرف الباحث.
  suivi_new_dossier_button: "ملف جديد",
  suivi_new_dossier_title: "ملف جديد",
  suivi_new_dossier_description:
    "أدخل رقم الملف ثم تكوين العائلة. سيتمكن الوالدان لاحقًا من إنشاء حسابهما بنفس هذا الرقم.",
  suivi_new_dossier_create: "إنشاء الملف",
  suivi_dossier_numero_label: "رقم الملف",
  suivi_dossier_numero_required: "رقم الملف إلزامي",
  suivi_dossier_members_required: "أضف عضوًا واحدًا على الأقل",
  suivi_dossier_exists: "هذا الملف موجود بالفعل",
  suivi_add_member_button: "إضافة عضو",
  suivi_add_member_title: "إضافة عضو",
  suivi_add_member_role_required: "اختر دورًا",
  suivi_add_member_confirm: "إضافة",
  suivi_add_member_done: "تمت إضافة العضو",
  suivi_remove_member_title: "إزالة هذا العضو",
  suivi_remove_member_text:
    "إزالة {{role}} من هذا الملف؟ هذا ممكن فقط ما دامت لم تُدخل أي بيانات.",
  suivi_remove_member_confirm: "إزالة",
  suivi_remove_member_done: "تمت إزالة العضو",
  suivi_remove_member_blocked:
    "لهذا العضو بيانات بالفعل ولا يمكن إزالته.",

  suivi_member_actions: "إجراءات",
  suivi_exit_member_title: "الخروج من الدراسة",
  suivi_exit_member_text:
    "لن يشارك {{name}} في الدراسة بعد الآن. تُحفظ البيانات التي جُمعت بالفعل؛ ولن يُنشأ أي استبيان جديد ولن تُرسل أي تذكيرات.",
  suivi_exit_dossier_title: "خروج الملف من الدراسة",
  suivi_exit_dossier_text:
    "سيخرج جميع أعضاء الملف {{name}} من الدراسة، بمن فيهم المرتبطون بمركز آخر. تُحفظ البيانات التي جُمعت بالفعل.",
  suivi_exit_reason_label: "السبب",
  suivi_exit_reason_withdrawal: "انسحاب",
  suivi_exit_reason_screen_failure: "غير مؤهل",
  suivi_exit_reason_lost: "انقطاع المتابعة",
  suivi_exit_reason_error: "خطأ في الإدراج",
  suivi_exit_reason_other: "أخرى",
  suivi_exit_note_label: "توضيح (اختياري)",
  suivi_exit_data_label: "البيانات المجمّعة بالفعل",
  suivi_exit_data_keep: "الاحتفاظ",
  suivi_exit_data_drop: "التوقف عن الاستخدام",
  suivi_exit_data_drop_warning:
    "ستُزال بيانات هذا الشخص من عمليات التصدير ولن تعود مرئية. لا يمكن التراجع عن هذا الإجراء.",
  suivi_exit_confirm: "تأكيد الخروج",
  suivi_exit_member_done: "تم تسجيل الخروج",
  suivi_exit_dossier_done: "تم إخراج الملف",
  suivi_exit_dossier_button: "خروج الملف من الدراسة",
  suivi_exited_tag: "خروج من الدراسة",
  suivi_exited_tag_reason: "خروج من الدراسة · {{reason}}",

  suivi_death_title: "تسجيل وفاة",
  suivi_death_text:
    "تسجيل وفاة {{name}}. تُحفظ البيانات ويستمر باقي الملف في متابعته.",
  suivi_death_date_label: "تاريخ الوفاة (اختياري)",
  suivi_death_confirm: "تسجيل",
  suivi_death_done: "تم تسجيل الوفاة",
  suivi_death_clear_title: "إلغاء الوفاة المسجّلة",
  suivi_death_clear_done: "تم إلغاء التسجيل",
  suivi_deceased_tag: "وفاة",

  suivi_access_link_title: "إرسال رابط الدخول",
  suivi_access_link_resend_title: "إعادة إرسال رابط الدخول",
  suivi_access_link_text:
    "سيتلقى {{name}} رابطًا لإنشاء حسابه والوصول إلى استبياناته.",
  suivi_access_link_email_label: "البريد الإلكتروني",
  suivi_access_link_confirm: "إرسال",
  suivi_access_link_done: "تم إرسال رابط الدخول",
  suivi_access_link_unavailable:
    "تعذّر إرسال الرابط: لا توجد وسيلة اتصال مسجّلة، أو لم تُهيَّأ أي دعوة لهذا الملف.",
  suivi_invited_on: "دُعي في {{date}}",

  // « التواريخ المرجعية » — قواعد الملف التي تستنتج التاريخ المرجعي لعضو (وضع العائلة).
  suivi_refdates: "التواريخ المرجعية",
  suivi_refdate_resolved: "التاريخ المعتمد: {{date}}",
  suivi_refdate_waiting: "قيد الانتظار — {{done}} من {{total}}",
  suivi_refdate_deceased: "(وفيات: {{n}})",
  suivi_refdate_missing: "ينقص: {{who}}",
  suivi_refdate_missing_hidden: "{{n}} خارج مركزكم",
  suivi_refdate_no_source: "لا يوجد تاريخ مصدر",
  suivi_refdate_no_source_death: "لا يوجد تاريخ مصدر — وفاة",
  suivi_refdate_unconfigured: "قاعدة يجب أن يكملها فريق البحث",
  suivi_refdate_member_missing: "التاريخ « {{label}} » مفقود",

  // « الموافقات » — حالة الخيارات لكل عضو، غيابات الملف، ملخّص الشروط.
  suivi_consents: "الموافقات",
  suivi_consent_granted: "مُنحت",
  suivi_consent_refused: "مرفوضة",
  suivi_consent_to_collect: "بانتظار الجمع",
  suivi_consent_source_in_app: "التطبيق",
  suivi_consent_source_paper: "ورقي",
  suivi_consent_source_phone: "هاتف",
  suivi_consent_source_other: "أخرى",
  suivi_consent_to_collect_tag: "موافقة بانتظار الجمع",
  suivi_action_collect_consent: "موافقة بانتظار الجمع",
  suivi_consent_action: "تسجيل الموافقات",
  suivi_consent_sheet_title: "تسجيل الموافقات",
  suivi_consent_sheet_text:
    "{{name}} — حدّد ما تم جمعه (استمارة ورقية، هاتف).",
  suivi_consent_not_seen: "لم تتم مقابلة الوالد",
  suivi_consent_yes: "نعم",
  suivi_consent_no: "لا",
  suivi_consent_unknown: "لم تُجمع",
  suivi_consent_source_label: "جُمعت عبر",
  suivi_consent_source_paper_choice: "استمارة ورقية",
  suivi_consent_source_phone_choice: "هاتف",
  suivi_consent_source_other_choice: "أخرى",
  suivi_consent_date_label: "تاريخ الجمع",
  suivi_consent_note_label: "ملاحظة (اختياري)",
  suivi_consent_refusal_warning:
    "الرفض يوقف الاستبيانات المعنية؛ ويبقى قرار إخراج الملف منفصلًا.",
  suivi_consent_confirm: "حفظ",
  suivi_consent_done: "تم تسجيل الموافقات",
  suivi_consent_conflict:
    "قام شخص آخر بتعديل هذه الموافقات للتو. حدّث الصفحة وحاول مجددًا.",
  suivi_consent_gate_title: "استبيانات {{role}}",
  suivi_consent_gate_waiting: "بانتظار {{roles}}",
  suivi_consent_gate_blocked: "متوقف — رفض من {{who}}",
  suivi_consent_gate_satisfied: "الشروط مستوفاة",
  suivi_consent_opposition_exit: "اعتراض — إخراج الملف",
  suivi_absence_declared_line:
    "لا يوجد {{role}} في هذا الملف — مُصرَّح ({{source}}، {{date}})",
  suivi_absence_declare_short: "التصريح بالغياب",
  suivi_absence_prompt: "لا يوجد {{role}} في هذا الملف؟",
  suivi_absence_declare: "لا يوجد {{role}} في هذا الملف",
  suivi_absence_declare_text:
    "هل تصرّح بعدم وجود {{role}} في هذا الملف؟ لن تنتظر الاستبيانات موافقته بعد الآن ولن تُعرض الدعوة. يُرفع التصريح تلقائيًا إذا سجّل {{role}} أو أعطى موافقته.",
  suivi_absence_declare_confirm: "تصريح",
  suivi_absence_clear: "إلغاء التصريح",
  suivi_absence_declared_done: "تم التصريح بالغياب",
  suivi_absence_cleared_done: "تم إلغاء التصريح",
  suivi_absence_has_member: "يوجد بالفعل {{role}} في هذا الملف.",
  suivi_exit_reason_opposition: "اعتراض على معالجة البيانات",

  invite_relative_menu_title: "دعوة {{role}}",
  invite_relative_menu_action: "دعوة",
  invite_relative_title: "دعوة",
  invite_relative_text:
    "سيتلقى الشخص رابطًا للانضمام إلى ملفك، والاطلاع على مذكرة المعلومات، وإنشاء حسابه.",
  invite_relative_unavailable: "لا تتوفر أي دعوة في الوقت الحالي.",
  invite_relative_firstname: "الاسم",
  invite_relative_lastname: "اللقب",
  invite_relative_email: "البريد الإلكتروني",
  invite_relative_role_required: "اختر من تريد دعوته.",
  invite_relative_fields_required: "يرجى ملء جميع الحقول.",
  invite_relative_confirm: "إرسال الدعوة",
  invite_relative_done: "تم إرسال الدعوة",
};
